import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { Link } from "@/mk2/components/Link";
import { Count, NotificationsBadge, Type } from "@/mk2/components/NotificationsBadge";

import styles from "./MobileMenu.mscss";

interface MobileMenuItemProps {
    title: string;
    itemUrl: string;
    isActive: boolean;
    level?: "1" | "2";
    numNotifications?: number | Count;
    numTiny?: number;
    isMainSection?: boolean;
    hasImportantNotifications?: boolean;
    urlNew?: string;
    isAdmin?: boolean;
    allowDataGoogleInterstitial?: boolean;
    onItemClick();
    onNewClick?();
}

export class MobileMenuItem extends React.PureComponent<MobileMenuItemProps> {
    public render() {
        const {
            title,
            numNotifications,
            isActive,
            numTiny,
            itemUrl,
            onItemClick,
            isMainSection,
            hasImportantNotifications,
            urlNew,
            isAdmin,
            level,
            allowDataGoogleInterstitial,
            onNewClick,
        } = this.props;

        return (
            <li
                onClick={onItemClick}
                className={cx(
                    styles.MobileMenu__mobileMenuItem,
                    styles[`MobileMenu__mobileMenuItem--level${level ?? "1"}`],
                    !!isMainSection && styles["MobileMenu__mobileMenuItem--mainSection"],
                    !!isAdmin && !isActive && styles["MobileMenu__mobileMenuItem--admin"], // black color for active admin items
                    !!isActive &&
                        cx(styles["MobileMenu__mobileMenuItem--active"], "topmenu-activeLink"),
                )}
            >
                <Link
                    className={cx(styles.MobileMenu__mobileMenuItemLink, "topmenu-mobilemenuLink")}
                    to={itemUrl}
                    data-google-interstitial={String(Boolean(allowDataGoogleInterstitial))}
                >
                    {title}
                    {!!numNotifications && Number(numNotifications) > 0 ? (
                        <NotificationsBadge
                            className={styles.MobileMenu__notificationsBadge}
                            count={numNotifications}
                            type={hasImportantNotifications ? Type.Important : undefined}
                        />
                    ) : !!numTiny && numTiny > 0 ? (
                        <span className={styles.MobileMenu__mobileMenuItemTinyNumber}>
                            {numTiny}
                        </span>
                    ) : null}
                </Link>
                {!!urlNew && (
                    <Link
                        to={urlNew}
                        className={cx(
                            styles.MobileMenu__mobileMenuItemAddIcon,
                            "topmenu-mobilemenuAddIcon",
                        )}
                        onClick={onNewClick}
                    >
                        <FontAwesomeIcon
                            icon={faPlusCircle}
                            className={styles.MobileMenu__mobileMenuItemAddIconFa}
                        />
                    </Link>
                )}
            </li>
        );
    }
}
